import React, { useEffect, useState } from 'react'
import { Box, CircularProgress } from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'
import { getMenusUserIDWise } from '../../features/menu/menuSlice'

export default function MenuProtectedRoute({ children, canAccess, redirectTo = '/Dashboard' }) {
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    const { navbarMenu, isLoading } = useSelector((state) => state.menus)
    const [requestedMenus, setRequestedMenus] = useState(false)

    useEffect(() => {
        if (user?.userID && navbarMenu.length === 0 && !requestedMenus) {
            setRequestedMenus(true)
            dispatch(getMenusUserIDWise({ userID: user.userID }))
        }
    }, [dispatch, navbarMenu.length, requestedMenus, user])

    if (!user) {
        return <Navigate to="/Login" replace />
    }

    if (navbarMenu.length === 0 && (isLoading || !requestedMenus)) {
        return (
            <Box sx={{ minHeight: '50vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        )
    }

    if (!canAccess(navbarMenu, user)) {
        return <Navigate to={redirectTo} replace />
    }

    return children
}